import { render, staticRenderFns } from "./UsersPageDetails.vue?vue&type=template&id=48ca4e5c&"
import script from "./UsersPageDetails.vue?vue&type=script&lang=ts&"
export * from "./UsersPageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ca4e5c')) {
      api.createRecord('48ca4e5c', component.options)
    } else {
      api.reload('48ca4e5c', component.options)
    }
    module.hot.accept("./UsersPageDetails.vue?vue&type=template&id=48ca4e5c&", function () {
      api.rerender('48ca4e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Provisioning/Users/UsersPageDetails.vue"
export default component.exports